<template>
  <div :class="{'navbar-menu-item': true, 'developer': menuItem.requiresDeveloper, 'active': isActiveLink}">
    <a ref="dropdownTrigger" data-toggle="dropdown" @click="menuClicked" :href="menuItem.link" aria-expanded="false">
      <i :class="['far', menuItem.icon]"></i> <span class="title">{{menuItem.name}}</span>
      <div class="navbar-menu-item-badge" v-if="menuItem.badge>0">{{menuItem.badge}}</div>
    </a>
    <ul class="dropdown-menu dropdown-lg" ref="dropdownMenu">
      <template v-for="childItem of menuItem.children">
        <h6 :key="`header-${childItem.name}`" class="navbar-menu-item-group-header" v-if="childItem.isHeader">{{childItem.name}}</h6>
        <DropdownMenuItem 
          v-if="!childItem.isHeader"
          :key="childItem.name"
          :icon="childItem.icon"
          :link="childItem.link">
          {{childItem.name}}
        </DropdownMenuItem>
        
        <template v-if="childItem.children">
          <template v-for="secondChildLevel of childItem.children">
            <DropdownMenuItem 
              v-if="!secondChildLevel.isHeader"
              :key="secondChildLevel.name"
              :icon="secondChildLevel.icon"
              :link="secondChildLevel.link">
              {{secondChildLevel.name}}
            </DropdownMenuItem>
          </template>
        </template>
      </template>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.navbar-menu-item {
  display: inline-block;
  position: relative;
  height: $layout-topnav-pill-height;
  line-height: calc(#{$layout-topnav-pill-height} - 4px);
  margin-left: 4px;
  margin-right: 4px;
  background-color: transparent;
  border: none;
  border-bottom: 4px solid transparent;
}
.navbar-menu-item .title {
  font-weight: 500;
}
.navbar-menu-item > a {  
  font-size: 0.8rem;
  vertical-align: middle;  
  color: #b7b7b7;
  border-radius: $layout-border-radius;
  padding: 8px 14px;
}
.navbar-menu-item > a:hover {
  background-color: #303030;
  color: #f0f0f0;
}
.navbar-menu-item.developer > a > i {
  font-size: 110%;
  font-weight: bold;
  color: $button-primary-color;
}
.navbar-menu-item.developer .title {
  display: none;
}

@media (max-width: 1500px) {
  .navbar-menu-item.developer {
    display: none;
  }
}

@media (max-width: 1400px) {
  .navbar-menu-item > a {
    padding-left: 6px;
    padding-right: 6px;
    margin-left: 2px;
    margin-right: 2px;
  } 
}
@media (max-width: 1300px) {
  .navbar-menu-item > a {
    font-size: 90%;
  }
  .navbar-menu-item > a > i {
    display: none;
  }
}

.navbar-menu-item.active {
  border-bottom: 4px solid $layout-topnav-menu-highlight;
  color: #ffffff;
}
.navbar-menu-item.active > a {
  color: #ffffff;
}

.navbar-menu-item > a > i {
  margin-right: 0.25rem;
}

.navbar-menu-item-badge {
  position: absolute;
  background-color: #ed5565;
  color: #ffffff;
  border-radius: 8px;
  right: 0;
  top: 8px;
  padding: 2px 5px;
  font-size: 0.7rem;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 600;
  text-shadow: none;
  line-height: 1;
  white-space: nowrap;
}

.navbar-menu-item-group-header {
  font-weight: bold;
  font-size: 14px;
  color: #909090;
  margin: 8px 10px 6px 6px;
}
</style>

<script>
export default {
  name: 'NavbarMenuItem',
  props: {
    menuItem: Object
  },
  watch: {
    '$route.meta.menuLink': function(newVal, oldVal) {
      this.$data.currentLink = this.$route.meta.menuLink

      // Hide the dropdown
      if($(this.$refs.dropdownMenu).hasClass('show')) {
        $(this.$refs.dropdownTrigger).dropdown('toggle')
        $(this.$refs.dropdownTrigger).dropdown('update')
      }
    }
  },
  data() {
    return {
      currentLink: this.$route.meta.menuLink
    }
  },
  computed: {
    isActiveLink() {
      // Check if children match this link
      // Only does 1 level currently
      if(this.menuItem == null)
        return false
      if(this.checkMenuListActive(this.menuItem.children))
        return true

      return this.menuItem.link == this.currentLink
    }
  },
  methods: {
    menuClicked(evt) {
      let totalChildCount = this.countTotalChildren(this.menuItem)
      var link = this.menuItem.link || ''
      
      // If only 1 child & it has a link, use that link
      if(totalChildCount == 1) {
        if(this.menuItem.children[0].link && this.menuItem.children[0].link != '')
          link = this.menuItem.children[0].link
      }

      if((this.menuItem.children == null || totalChildCount < 2) && link != '') {
        this.$router.push(link)
        evt.stopPropagation()
        evt.preventDefault()
        return
      }
    },
    checkMenuListActive(menuItems) {
      if(menuItems != null) {
        for(var item of menuItems) {
          if(item.link == this.currentLink)
            return true

          if(this.checkMenuListActive(item.children))
            return true
        }
      }
      return false
    },
    countTotalChildren(menuItem) {
      // Count all children in this menu item & under each child recursively
      if(menuItem == null || menuItem.children == null)
        return 0

      var childCount = menuItem.children.reduce((curCount, child) => {
        return curCount + this.countTotalChildren(child) + 1
      }, 0)

      return childCount
    }
  }
}
</script>